import React from 'react'

import PropertyError from '../errors/PropertyError'

class PropertyErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.log('Handling Property Error > Rendering PropertyError Component')
  }

  render() {
    if (this.state.hasError) {
      return <PropertyError />
    }

    return this.props.children
  }
}

export default PropertyErrorBoundary
